// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__kPw+o","chart-title":"Chart_chart-title__AuBKv"};